import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button'
import PTextarea from './PTextarea';
// import DefaultLogo from '../images/default-img.jpg';
// import { s3Link } from '../utils/constants';
import AlertConfirmModal from './AlertConfirmModal';
import Avatar from './Avatar'

const CommentItem = ({
    comment,
    index,
    deleteHandler,
    post,
    subIndex=null,
    setCommentHandler
}) => {
    const [showComment, setShowComment] = useState(false);
    const handleReplyComment = () => setShowComment(!showComment);

    const [likes, setLikes] = useState(comment.likes)
    const [isLiked, setIsLiked] = useState(comment.is_liked_by_user)
    const [caption, setCaption] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [activeComment, setActiveComment] = useState(false)
    const [editCaption, setEditCaption] = useState('')
    const [userInformation, setUserInformation] = useState({})

    const [show, setShow] = useState(false);
    const [hasConfirm, setHasConfirm] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [apiError, setApiError] = useState('');

    useEffect(() => {
        let mounted = true
        setUserInformation(JSON.parse(localStorage.getItem('user')))
        return () => {
            mounted = false
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)

        await axios.post('/api/comments', {
            comment: caption,
            post_id: post.id,
            comment_id: comment.id,
        }).then(response => {
            setCaption('')
            setCommentHandler(index, null, response.data, 'add', true)
            setShowComment(false)
        }).catch(error => {
            if (error.response.status === 404) {
                setApiError('The comment reply failed as the comment has been deleted.');
            }
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault()
        setIsLoading(true)

        await axios.patch(`/api/comments/${comment.id}`, {
            comment: editCaption
        }).then(response => {
            setCommentHandler(index, subIndex, editCaption, 'edit')
            setEditCaption('')
            setActiveComment({})
        })
        .catch(error => {
            if (error.response.status === 404) {
                setApiError('The update failed as the comment has been deleted.');
            }
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    const handleCommentDeleteConfirm = () => {
        setAlertText('Are you sure you want to delete this comment?');
        setShow(true)
        setHasConfirm(true)
    }

    const handleCommentDelete = async() => {
        await axios.delete(`/api/comments/${comment.id}`)
            .then(response => {
                console.log({ index, subIndex })
                deleteHandler(index, subIndex)
            }).catch(error => {
                if (error.response.status === 404) {
                    setApiError('The delete failed as the comment has been deleted.');
                }
            })
    }

    const handleLike = async () => {
        await axios.post(`/api/comments/${comment.id}/likes`)
            .then(response => {
                const userIndex = likes.findIndex(like => like.user_id === userInformation.id)

                if (userIndex >= 0) {
                    likes.splice(userIndex, 1)
                } else {
                    likes.push({
                        user_id: userInformation.id
                    })
                }

                setLikes(likes)
                setIsLiked(!isLiked)
            }).catch(error => {
                if (error.response.status === 404) {
                    setApiError('The comment like failed as the comment has been deleted.');
                }
            })
    }

    const handleEdit = () => {
        setActiveComment(comment)
        setEditCaption(comment.comment)
    }

    const closeApiErrorAlert = () => {
        setApiError('');
    }

    return (
        <>
        <AlertConfirmModal modalTitle="" modalBody={alertText} show={show} setShow={setShow} isConfirm={hasConfirm} useFunction={handleCommentDelete} />

        <AlertConfirmModal modalTitle="" modalBody={apiError} show={apiError !== ''} setShow={closeApiErrorAlert} isConfirm={false} useFunction={closeApiErrorAlert} />

        <div className={`comment-list-item ${subIndex !== null ? 'ml-5' : ''}`}>
            <div className="cmt-user-img-lft">
                <Avatar pu={comment.user} story={false} size="40" />
            </div>
            <div className="cmt-usr-rgt">
                <div className="cmt-usr-rply">
                    <div className="cmt-usr-nme">
                        <span>
                            {
                                comment.user && comment.user.login
                                    ? <Link to={'/' + `${comment.user.login}`}>{comment.user.login}</Link>
                                    : 'Unknown'
                            }
                        </span>
                    </div>
                    <div className="cmt-rply-txt">
                        {
                            Object.keys(activeComment).length <= 0 && <span>{comment.comment}</span>
                        }
                    </div>
                </div>
                <div className="time-reply">
                    <span>{ moment.utc(comment.created_at).local().fromNow() }</span>
                    {
                        subIndex === null && <span><a onClick={handleReplyComment}>Reply</a></span>
                    }
                </div>
                <div className="like-btn">
                    <a onClick={handleLike}>
                        <FontAwesomeIcon
                        icon={isLiked ? ['fas', 'heart'] : ['far', 'heart']}
                        color={isLiked ? '#DA005E' : ''}
                        />
                        {' '}
                        {comment.likes.length}
                    </a>
                </div>
                {
                    userInformation && userInformation.id === comment.user_id && <div className="edit-delete-comment">
                        <Dropdown drop="down">
                            <Dropdown.Toggle variant="success" id="post-list-dropdown">
                                <FontAwesomeIcon icon={['fas', 'circle']} />
                                <FontAwesomeIcon icon={['fas', 'circle']} />
                                <FontAwesomeIcon icon={['fas', 'circle']} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu align="right">
                                <Dropdown.Item onClick={handleCommentDeleteConfirm}>
                                Delete
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleEdit}>
                                Edit
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                }
                {
                    userInformation && userInformation.id !== comment.user_id && post.pu_id === userInformation.id  && <div className="edit-delete-comment">
                    <Dropdown drop="down">
                        <Dropdown.Toggle variant="success" id="post-list-dropdown">
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                            <FontAwesomeIcon icon={['fas', 'circle']} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="right">
                            <Dropdown.Item onClick={handleCommentDeleteConfirm}>
                            Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                }
            </div>
            {
                Object.keys(activeComment).length > 0 && <form className="comment_form" method="patch" name="comment_form">
                    <div className="comment_form_field">
                    <PTextarea
                        caption={editCaption}
                        setCaption={setEditCaption}
                        placeholder="Write your reply.."
                        checkRole={false}
                    />
                    </div>
                    <div className="comment_form_submit_cont">
                        <Button
                            type="submit"
                            className="comment_form_submit-btn"
                            onClick={handleSubmitEdit}
                            disabled={isLoading}
                        >
                            {isLoading
                            ? <Spinner animation="border" variant="light" />
                            : <FontAwesomeIcon icon={['fas', 'paper-plane']} />}
                        </Button>
                    </div>
                </form>
            }
        </div>
        { showComment &&
            <form className="comment_form" method="post" name="comment_form">
                <div className="comment_form_field">
                <PTextarea
                    caption={caption}
                    setCaption={setCaption}
                    placeholder="Write your reply.."
                    checkRole={false}
                />
                </div>
                <div className="comment_form_submit_cont">
                    <Button
                        type="submit"
                        className="comment_form_submit-btn"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading
                        ? <Spinner animation="border" variant="light" />
                        : <FontAwesomeIcon icon={['fas', 'paper-plane']} />}
                    </Button>
                </div>
            </form>
        }
        </>
    );
}

export default CommentItem;
